import React, { useEffect } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import {
  trackGAEvent,
  createGenericImpressionEvent,
  createGenericSelectContentEvent,
} from '@moonpig/web-core-analytics'
import { MessageType, Suggestion } from '../ChatMessages/types'
import {
  useChatGatewayContext,
  useChatMessagesContext,
  useChatModeContext,
} from '../ChatContext'
import { SuggestionsAgentMessage } from '../components/SuggestionsMessage'

const StyledBox = styled(Box)`
  ${s({
    pl: 5,
    pr: 5,
    pb: 4,
  })}
  max-width: 100%;
  align-items: start;
`

export const InputSuggestions = () => {
  const { sendMessage, flagLocalInteractionToGateway } = useChatGatewayContext()
  const { messages, addUserMessage } = useChatMessagesContext()
  const { trackedSuggestions } = useChatModeContext()

  const lastMessage = messages[messages.length - 1]
  const currentSuggestionContent =
    lastMessage?.type === MessageType.Suggestions &&
    !lastMessage.content.supportUrl &&
    lastMessage.content.source === 'agent'
      ? lastMessage.content
      : null

  useEffect(() => {
    if (
      !currentSuggestionContent ||
      trackedSuggestions.current.has(currentSuggestionContent)
    ) {
      return
    }

    trackedSuggestions.current.add(currentSuggestionContent)
    trackGAEvent(
      createGenericImpressionEvent({
        category: 'ai concierge',
        action: 'clarify prompt',
        label: `suggestion tiles loaded | ${currentSuggestionContent.suggestions.length}`,
      }),
    )
  }, [currentSuggestionContent, trackedSuggestions])

  const suggestionClickHandler = (
    suggestion: Suggestion,
    suggestionOptions: number,
  ) => {
    flagLocalInteractionToGateway()
    addUserMessage(suggestion.text)
    sendMessage(suggestion.text)

    trackGAEvent(
      createGenericSelectContentEvent({
        eventCategory: 'ai concierge',
        eventAction: 'clarify prompt click',
        eventLabel: `suggestion tile | ${suggestion.id}/${suggestionOptions}`,
      }),
    )
  }

  return (
    <StyledBox>
      {currentSuggestionContent && (
        <SuggestionsAgentMessage
          id={messages.length - 1}
          suggestionClickHandler={suggestionClickHandler}
          title={currentSuggestionContent.title}
          suggestions={currentSuggestionContent.suggestions}
        />
      )}
    </StyledBox>
  )
}
